import Alpine from "alpinejs";
import Clipboard from "@ryangjchandler/alpine-clipboard";

import './components/addresses';
import './components/accountBalance';
import './components/checkoutOverview';
import './components/filter';
import './components/form';
import './components/header';
import initNotifications from './components/notifications';

window.jQuery = window.$ = require('jquery');
window.bootstrap = require('bootstrap');

Alpine.plugin(Clipboard);

window.Alpine = Alpine;

document.addEventListener('alpine:init', () => {
    initNotifications();
})

window.Alpine.start();

const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
tooltipTriggerList.map((tooltipTriggerEl) => new bootstrap.Tooltip(tooltipTriggerEl))
